import * as THREE from "three";
import React, { useRef, useEffect, memo } from "react";
import { useFrame } from "@react-three/fiber";
import Control from '../store/control';

const MLine = memo(({ color, axisMove, axisShow, linewidth=1, fix=false, isCenter=false, isCenterX=false, isCenterZ=false}) => {
  const origin = Control.Get("origin");
  const setControl = Control.Get("setControl");
  const click      = Control.Get("click");

  const ref  = useRef();

  useFrame(() => {
    ref.current.material.linewidth = linewidth;
  });

  // This if for initial line position
  useEffect(() => {
    // show ischial level line
    if (ref.current) {
      if (axisMove == "y") {
        if (axisShow == 'z') {
          const maxZ = 500
          const points = [new THREE.Vector3(0, 0, -maxZ), new THREE.Vector3(0, 0, maxZ)]
          ref.current.geometry.setFromPoints(points)
        }
      }
    }
  }, []);

  useEffect(() => {
    if((click != null) && (fix==false) ){
      if(axisMove == "x"){ // For Center X
        //setControl(s => {s.origin = new THREE.Vector3(click.x, 0, 0)});
        setControl(s => {s.origin = new THREE.Vector3(click.x, origin.y, origin.z)});
        console.log('set origin.x = ', click.x);
      }
      else if(axisMove == "y"){ // For MPT
        setControl(s => {s.origin = new THREE.Vector3(origin.x, click.y, origin.z)});
        console.log('set origin.y = ', click.y);
      }
      else if(axisMove == "z"){ // For Center Y
        setControl(s => {s.origin = new THREE.Vector3(origin.x, origin.y, click.z)});
        console.log('set origin.z = ', click.z);
      }
      setControl(s => {s.click = null});

      if (isCenter) {
        setControl(s => {s.toModifyYheight = true});
        setControl(s => {s.redrawBox += 1});
      }

      if (isCenterX) {
        setControl(s => {s.toModifyX = true});
        setControl(s => {s.redrawBox += 1});
      }

      if (isCenterZ) {
        setControl(s => {s.toModifyZ = true});
        setControl(s => {s.redrawBox += 1});
      }
    }
  }, [click]);

  //useFrame(({ click }) => {
  useEffect(() => {
    //const x = mouse.x * viewport.width / 2 / camera.zoom;
    //const y = mouse.y * viewport.height / 2 / camera.zoom;

    if((click != null) && (fix==false) ){
      console.log(click)

      const x = click.x;
      const y = click.y;
      const z = click.z;

      const maxX = (axisShow == "x") ? 500 : 0;
      const maxY = (axisShow == "y") ? 500 : 0;
      const maxZ = (axisShow == "z") ? 500 : 0;

      // TODO: change condition from axisMove to axisShow
      // https://codesandbox.io/embed/react-three-fiber-line-jcenh
      if(axisMove == "x"){ // For Center X
        const points = [new THREE.Vector3(x, -maxY, 0), new THREE.Vector3(x, maxY, 0)]
        ref.current.geometry.setFromPoints(points)
      }
      else if(axisMove == "y") { 
        if (axisShow == 'x') {// For MPT
          const points = [new THREE.Vector3(-maxX, 0, 0), new THREE.Vector3(maxX, 0, 0)]
          //const points = [new THREE.Vector3(-maxX, y, 0), new THREE.Vector3(maxX, y, 0)]
          ref.current.geometry.setFromPoints(points)
        } else if (axisShow == 'z') { // For Ischium AK 
          const points = [new THREE.Vector3(0, y, -maxZ), new THREE.Vector3(0, y, maxZ)]
          ref.current.geometry.setFromPoints(points)
        }
      }
      else if(axisMove == "z"){ // For Center Y
        const points = [new THREE.Vector3(0, -maxY, z), new THREE.Vector3(0, maxY, z)]
        ref.current.geometry.setFromPoints(points)
      }
    }
  }, [click]);
  
  return (
    <line ref={ref} renderOrder={1}>
      <bufferGeometry attach="geometry" />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});

export default MLine;
